// As cores e os estilos partilhados dos graficos. As cores sao variaveis CSS (index.css, --chart-1 a
// --chart-8) e seguem o data-theme sem codigo. Uma serie tem sempre a mesma cor, escolhida pela
// chave e nunca pela ordem (spec do RPAA-286, decisao 12): quem desenha passa um mapa chave ->
// posicao da paleta, e uma chave fora do mapa (um valor novo que o backend comece a mandar) fica a
// cinzento.
export const MUTED = "var(--chart-muted)";

export const slotColor = (slot) => `var(--chart-${slot})`;

export const colorFor = (slots, key) => (slots && slots[key] ? slotColor(slots[key]) : MUTED);

export const TOOLTIP_STYLE = {
  background: "var(--color-surface-raised)",
  color: "var(--color-text-primary)",
  border: "1px solid var(--color-border)",
  borderRadius: 8,
  padding: "6px 8px",
  fontSize: 12,
  pointerEvents: "none",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  whiteSpace: "nowrap",
  zIndex: 4,
};

// O texto dos eixos usa a cor do texto secundario, nunca a de uma serie.
export const AXIS_LABEL = { fill: "var(--color-text-secondary)", fontSize: 11 };
